import React, { useEffect, useState } from "react";

import { getRgbPhotoBlobApi } from "../api/rgbApi";

type Props = {
  token: string;
  assetId: string;
  alt: string;
  className?: string;
};

/**
 * Foto do apontamento. `GET /uploads/images/:assetId` exige JWT e `<img src>` não
 * manda o token — a imagem vem como blob e vira object URL, revogado ao trocar
 * ou desmontar (mesmo padrão do `AuthImage` da avaliação de loja).
 */
export default function RgbPhoto({ token, assetId, alt, className }: Props) {
  const [src, setSrc] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let url: string | null = null;
    let cancelled = false;
    setSrc(null);
    setFailed(false);

    getRgbPhotoBlobApi(token, assetId)
      .then((blob) => {
        if (cancelled) return;
        url = URL.createObjectURL(blob);
        setSrc(url);
      })
      .catch(() => !cancelled && setFailed(true));

    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [token, assetId]);

  if (failed) return <span className="rgbMuted">Imagem indisponível</span>;
  if (!src) return <span className="rgbMuted">Carregando...</span>;
  return <img src={src} alt={alt} className={className} />;
}
